var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPesquisaAva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3B-Liner_Desktop_Home_Escuro",
    transform: "translate(-887.000000, -764.000000)",
    stroke: "",
    strokeWidth: 1.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "mn-copy-3",
    transform: "translate(645.000000, 633.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-57",
    transform: "translate(243.039097, 131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pesquisa_ava",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.46090253,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68895724,14.0418613 L0.00276387502,11.3501402",
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    transform: "translate(1.345861, 12.696001) rotate(-270.000000) translate(-1.345861, -12.696001) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.48358305,
    y1: 3.38817648,
    x2: 7.48358305,
    y2: 9.64456912,
    id: "Line-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.49364812,
    y1: 3.40554156,
    x2: 7.49364812,
    y2: 9.62720403,
    id: "Line-3-Copy",
    strokeLinecap: "round",
    transform: "translate(7.493648, 6.516373) rotate(-90.000000) translate(-7.493648, -6.516373) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesquisaAva);
export default __webpack_public_path__ + "static/media/pesquisa_ava.48738917297d32f7f3caed515eb42d10.svg";
export { ForwardRef as ReactComponent };